
<div class="custom-card">
  <div class="header-reports">
    <wm-common-text
      [data]="{
        text: 'Requested Reports',
        fontSize: '28px',
        fontWeight: '400',
      }"
    ></wm-common-text>
    <wm-common-text
      [data]="{
        text: 'You may navigate away from this page and come back later to view your report.',
        fontSize: '14px',
        fontWeight: '400',
        color: 'red'
      }"
    ></wm-common-text>
    <!-- <h3>Requested Reports</h3> -->
    <!-- <h6>You may navigate away from this page and come back later to view your report.</h6> -->
  </div>
  <wm-common-table
    tableType="Staff"
    [columns]="columns"
    [data]="rows"
  ></wm-common-table>
</div>
